// components/file-upload.js
// ═══════════════════════════════════════════════════════════
// File upload ingredient. Drop into any feature input bar.
// Owns: file picker trigger, base64 encoding, type validation
// Never owns: what happens with the file (calls onFile prop)
// Feature decides: send to brain, process as content, etc.
// ═══════════════════════════════════════════════════════════
import { useRef } from 'react';

const ACCEPTED_TYPES = [
  'image/jpeg', 'image/png', 'image/gif', 'image/webp',
  'application/pdf',
  'text/plain', 'text/csv',
  'application/json',
].join(',');

export default function FileUpload({
  onFile,
  accept = ACCEPTED_TYPES,
  disabled = false,
  children,
}) {
  const inputRef = useRef(null);

  function handleClick() {
    if (disabled) return;
    inputRef.current?.click();
  }

  async function handleChange(e) {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result.split(',')[1];
      onFile?.({
        file,
        base64,
        name: file.name,
        type: file.type,
        size: file.size,
      });
    };
    reader.readAsDataURL(file);

    e.target.value = '';
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
      <button
        onClick={handleClick}
        disabled={disabled}
        style={{
          background: 'none',
          border: 'none',
          cursor: disabled ? 'default' : 'pointer',
          padding: 0,
          lineHeight: 1,
        }}
        onMouseEnter={e => { if (!disabled) e.currentTarget.querySelectorAll('path').forEach(el => el.setAttribute('stroke', '#7a9e82')); }}
        onMouseLeave={e => { if (!disabled) e.currentTarget.querySelectorAll('path').forEach(el => el.setAttribute('stroke', '#888888')); }}
      >
        {children || (
          <svg width="20" height="20" viewBox="0 0 18 18" fill="none">
            <path d="M9 12V4" stroke="#888888" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M5.5 7L9 3.5L12.5 7" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 13.5v1a1 1 0 001 1h10a1 1 0 001-1v-1" stroke="#888888" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        )}
      </button>
    </>
  );
}